module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "id": "routerTemp"
    }
  }, [_c('p', {
    attrs: {
      "id": "author"
    }
  }, [_vm._v("iOS=>WebAPP之路")]), _vm._v(" "), _vm._m(0), _vm._v(" "), _c('button', {
    attrs: {
      "type": "success",
      "name": "button",
      "icon": "share"
    },
    on: {
      "click": _vm.onClick
    }
  })])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('a', {
    attrs: {
      "href": "https://github.com/jakajacky",
      "target": "_blank"
    }
  }, [_c('p', {
    attrs: {
      "id": "author"
    }
  }, [_vm._v("GitHub")])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-a610fea0!./~/vue-loader/lib/selector.js?type=template&index=0!./src/component/routerTemp.vue
// module id = 90
// module chunks = 2